import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { SmartScheduleOnboardingBoardSelectorProps } from './SmartScheduleOnboardingBoardSelector';

export const LazySmartScheduleOnboardingBoardSelector: FunctionComponent<
  SmartScheduleOnboardingBoardSelectorProps
> = (props) => {
  const SmartScheduleOnboardingBoardSelector = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "smart-schedule-onboarding-board-selector" */ './SmartScheduleOnboardingBoardSelector'
      ),
    { namedImport: 'SmartScheduleOnboardingBoardSelector' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Smart Schedule Onboarding Board Selector',
      }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <SmartScheduleOnboardingBoardSelector {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
